import { useEffect, useState } from "react";
import { http } from "@/lib/api";

// Normalize a DB article to match the shape used by static entries.
// Change makers use `hero_image`; DB articles use `featured_image`. Alias here.
const normalize = (a) => ({
  ...a,
  hero_image: a.hero_image || a.featured_image,
  featured_image: a.featured_image || a.hero_image,
  tagline: a.tagline || a.subtitle,
  subtitle: a.subtitle || a.tagline,
  _source: "db",
});

export const useArticles = (section) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    http
      .get("/articles", { params: { section } })
      .then((r) => {
        if (!cancelled) setItems(r.data.map(normalize));
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [section]);

  return { items, loading };
};

export const useArticle = (slug) => {
  const [article, setArticle] = useState(undefined); // undefined loading, null not-found, object found
  useEffect(() => {
    let cancelled = false;
    http
      .get(`/articles/${slug}`)
      .then((r) => { if (!cancelled) setArticle(normalize(r.data)); })
      .catch(() => { if (!cancelled) setArticle(null); });
    return () => { cancelled = true; };
  }, [slug]);
  return article;
};
